import React from "react";
import Layout from "../../layouts/Layout";
import { SectionTitle } from "../../components";
import { AuthForm } from "../../containers";
const LoginRegister = () => {
 
  

  return (
    <Layout title={"Login/Register "}>
      <div className="dg__market__data pt--130 pb--80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <SectionTitle title={"Login/Register"} />
              <AuthForm  />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default LoginRegister;
